import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { ChatCsat } from "@faire/help-center-self-serve/chat/views/ChatCsat";
import { getIsLoggedInUser } from "@faire/help-center-utils/serialized-data/getUser";
import { hasShortcutsAccess } from "@faire/help-center-utils/serialized-data/shortcutsAccess";
import { getSettingHelpCenterIssueSearch } from "@faire/help-center-utils/settings/getSettingHelpCenterIssueSearch";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { Route } from "@faire/web--source/ui/routing/Route";
import { Switch } from "@faire/web--source/ui/routing/Switch";
import { path as supportPath, route as supportRoute } from "@faire/web-api--source/routes/support";
import { route as supportSelfServeRoute } from "@faire/web-api--source/routes/support/self-serve";
import { route as supportSelfServeChatCsat } from "@faire/web-api--source/routes/support/self-serve/chat-csat";
import { route as supportSelfServeEmailRoute } from "@faire/web-api--source/routes/support/self-serve/email";
import { route as supportSelfServeIssueSearchRoute } from "@faire/web-api--source/routes/support/self-serve/issue-search";
import { route as supportSelfServeIssueSelectRoute } from "@faire/web-api--source/routes/support/self-serve/issue-select";
import { route as supportSelfServeOrderSelectRoute } from "@faire/web-api--source/routes/support/self-serve/order-select";
import { route as supportSelfServePhoneRoute } from "@faire/web-api--source/routes/support/self-serve/phone";
import { route as supportSelfServePhoneSubmissionConfirmationRoute } from "@faire/web-api--source/routes/support/self-serve/phone-submission-confirmation";
import { route as supportSelfServeRecommendedArticleRoute } from "@faire/web-api--source/routes/support/self-serve/recommended-article";
import { route as supportSelfServeEmailSubmissionConfirmationRoute } from "@faire/web-api--source/routes/support/self-serve/submission-confirmation";
import { route as supportSelfServeTopicsRoute } from "@faire/web-api--source/routes/support/self-serve/topics";
import React from "react";
import { Redirect } from "react-router-dom";
import { useNavigationInitializationEffect } from "./hooks/useNavigationInitializationEffect";
import { Answer } from "./view/Answer/Answer";
import { SelfServeContentWrapper } from "./view/components/SelfServeContentWrapper";
import { EmailUsForm } from "./view/Email/EmailUsForm";
import { EmailSubmitted } from "./view/EmailSubmitted/EmailSubmitted";
import { Home } from "./view/Home/Home";
import { HomeWithShortcuts } from "./view/Home/HomeWithShortcuts";
import { IssueSearch } from "./view/IssueSearch/IssueSearch";
import { MoreIssue } from "./view/MoreIssue/MoreIssue";
import { Order } from "./view/Order/Order";
import { isPhoneInBusinessHours } from "./view/Phone/isPhoneInBusinessHours";
import { Phone } from "./view/Phone/Phone";
import { usePhoneAuthorization } from "./view/Phone/usePhoneAuthorization";
import { SelfServeSkeleton } from "./view/SelfServeSkeleton";
import { StepPage } from "./view/step";
export var SelfServeRouter = function SelfServeRouter(_ref) {
  var queryState = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  var isLoggedInUser = getIsLoggedInUser();
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  var _usePhoneAuthorizatio = usePhoneAuthorization(),
    hasPhoneAccess = _usePhoneAuthorizatio.hasPhoneAccess;
  useNavigationInitializationEffect();
  var renderStep = function renderStep(stepPage) {
    var pageToRender;
    switch (stepPage) {
      case StepPage.TOPIC_SELECTION:
        pageToRender = !isMobile && hasShortcutsAccess() ? (/*#__PURE__*/React.createElement(HomeWithShortcuts, _objectSpread({}, queryState))) : (/*#__PURE__*/React.createElement(Home, _objectSpread({}, queryState)));
        break;
      case StepPage.ORDER_SELECTION:
        pageToRender = /*#__PURE__*/React.createElement(Order, null);
        break;
      case StepPage.TELL_US_MORE:
        pageToRender = /*#__PURE__*/React.createElement(SelfServeContentWrapper, {
          leftSection: /*#__PURE__*/React.createElement(MoreIssue, null)
        });
        break;
      case StepPage.ANSWER:
        pageToRender = /*#__PURE__*/React.createElement(SelfServeContentWrapper, {
          leftSection: /*#__PURE__*/React.createElement(Answer, null)
        });
        break;
      case StepPage.EMAIL_FORM:
        pageToRender = /*#__PURE__*/React.createElement(SelfServeContentWrapper, {
          leftSection: /*#__PURE__*/React.createElement(EmailUsForm, null)
        });
        break;
      case StepPage.PHONE_FORM:
        pageToRender = /*#__PURE__*/React.createElement(SelfServeContentWrapper, {
          leftSection: /*#__PURE__*/React.createElement(Phone, null)
        });
        break;
      case StepPage.EMAIL_SUBMISSION_CONFIRMATION:
        pageToRender = /*#__PURE__*/React.createElement(SelfServeContentWrapper, {
          leftSection: /*#__PURE__*/React.createElement(EmailSubmitted, {
            supportType: "email"
          })
        });
        break;
      case StepPage.PHONE_SUBMISSION_CONFIRMATION:
        pageToRender = /*#__PURE__*/React.createElement(SelfServeContentWrapper, {
          leftSection: /*#__PURE__*/React.createElement(EmailSubmitted, {
            supportType: "phone"
          })
        });
        break;
      case StepPage.ISSUE_SEARCH:
        pageToRender = /*#__PURE__*/React.createElement(IssueSearch, null);
        break;
      default:
        pageToRender = /*#__PURE__*/React.createElement(Home, _objectSpread({}, queryState));
        break;
    }
    return /*#__PURE__*/React.createElement(SelfServeSkeleton, null, pageToRender);
  };
  return /*#__PURE__*/React.createElement(Switch, null, isLoggedInUser ? null : (/*#__PURE__*/React.createElement(Redirect, {
    to: supportPath({
      contact: "true"
    })
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: supportSelfServeRoute,
    render: function render() {
      return renderStep(StepPage.TOPIC_SELECTION);
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: supportSelfServeTopicsRoute,
    render: function render() {
      return renderStep(StepPage.TOPIC_SELECTION);
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: supportSelfServeOrderSelectRoute,
    render: function render() {
      return renderStep(StepPage.ORDER_SELECTION);
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: supportSelfServeIssueSelectRoute,
    render: function render() {
      return renderStep(StepPage.TELL_US_MORE);
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: supportSelfServeRecommendedArticleRoute,
    render: function render() {
      return renderStep(StepPage.ANSWER);
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: supportSelfServeEmailRoute,
    render: function render() {
      return renderStep(StepPage.EMAIL_FORM);
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: supportSelfServeEmailSubmissionConfirmationRoute,
    render: function render() {
      return renderStep(StepPage.EMAIL_SUBMISSION_CONFIRMATION);
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: supportSelfServePhoneSubmissionConfirmationRoute,
    render: function render() {
      return renderStep(StepPage.PHONE_SUBMISSION_CONFIRMATION);
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: supportSelfServeChatCsat,
    render: function render() {
      return /*#__PURE__*/React.createElement(ChatCsat, null);
    }
  }), hasPhoneAccess && isPhoneInBusinessHours() ? (/*#__PURE__*/React.createElement(Route, {
    path: supportSelfServePhoneRoute,
    render: function render() {
      return renderStep(StepPage.PHONE_FORM);
    }
  })) : null, getSettingHelpCenterIssueSearch() ? (/*#__PURE__*/React.createElement(Route, {
    path: supportSelfServeIssueSearchRoute,
    render: function render() {
      return renderStep(StepPage.ISSUE_SEARCH);
    }
  })) : null, /*#__PURE__*/React.createElement(Redirect, {
    to: supportRoute
  }));
};